import React from "react";
import QueueAnim from 'rc-queue-anim';
import './style.less'
import { Card, Row, Col } from 'antd';

const { Meta } = Card;

export default class ParametersContent extends React.Component {

    render() {
        return (
            <div className="gcs-description-container">
                <div className="description">
                    <div className='line'>
                        <Row>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/2screen.png" alt={""} />
                                <p>双屏设计<br />航线与视频分开显示</p>
                            </Col>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/controller.png" alt={""} />
                                <p>便携式带轮地面站箱<br />可手提，防震防尘</p>
                            </Col>
                            <Col span="8">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E6%8E%A7%E5%88%B6%E9%81%A5%E6%84%9F.png" alt={""} />
                                <p>内置云台控制摇杆<br />流畅精准</p>
                            </Col>
                        </Row>
                    </div>
                    <div className='line'>
                        <Row>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/7H.png" alt={""} />
                                <p>7小时超长续航<br />足够全天使用</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/spreadControl.png" alt={""} />
                                <p>人体工学设计，合理<br />分区操作，互不干扰</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E7%9C%9F%E7%9A%AE%E9%9D%A2%E6%9D%BF.png" alt={""} />
                                <p>真皮面板<br />舒适的操作体验</p>
                            </Col>
                            <Col span="6">
                                <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E7%94%B5%E5%AD%90%E8%AE%BE%E5%A4%87%E5%85%85%E7%94%B5.png" alt={""} />
                                <p>地面站内置电池可为笔记本电脑<br />手机等电子设备充电</p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

        )

    }
}
